import { ArrowCounterClockwise } from '@phosphor-icons/react';
import { directActionOptions } from '@/lib/documentActions';

export const DocumentActionPins = ({ type, preferences: p }) => {
  const options = directActionOptions(type);
  const selected = p.primary_actions || [];
  const change = (index, key) => {
    const next = [...selected];
    next[index] = key;
    p.setPrimary(next.filter(Boolean));
  };
  return <section className="px-4 py-3 border-b border-gray-100" data-testid="direct-actions-settings">
    <div className="flex items-center justify-between mb-2">
      <span className="text-xs font-semibold text-gray-800" data-testid="direct-actions-count">Direct zichtbaar ({selected.length}/5)</span>
      <button type="button" disabled={!p.ready} onClick={p.resetPrimary} className="p-1 text-gray-500 hover:text-blue-700" title="Standaardacties herstellen" aria-label="Standaardacties herstellen" data-testid="direct-actions-reset"><ArrowCounterClockwise size={15} /></button>
    </div>
    {[0, 1, 2, 3, 4].map(index => <div key={index} className="flex items-center gap-2 mt-1.5">
      <span className="text-[11px] text-gray-500 w-3">{index + 1}</span>
      <select className="field-input !text-xs !py-1 min-w-0 flex-1" value={selected[index] || ''} disabled={!p.ready}
        onChange={e => change(index, e.target.value)} aria-label={`Directe actie ${index + 1}`} data-testid={`direct-action-slot-${index + 1}`}>
        <option value="">Geen extra knop</option>
        {options.filter(option => !selected.includes(option.key) || selected[index] === option.key).map(option => <option key={option.key} value={option.key}>
          {option.label}{p.actions[option.group || option.key] === false ? ' (verborgen)' : ''}
        </option>)}
      </select>
    </div>)}
  </section>;
};